import styled from 'styled-components';

export const StyledPagination = styled.div`
  max-width: 50%;
`;
